import React, { useEffect } from 'react';

/**
 * Smart TV HTML5 App — redirects to the backend's optimized Smart TV view.
 * Serves as the React router entry point for /tv
 */
export default function SmartTVPage() {
  useEffect(() => {
    const base = process.env.REACT_APP_BACKEND_URL || window.location.origin;
    window.location.replace(`${base}/api/platform/smart-tv`);
  }, []);

  return (
    <div style={{
      background: '#0A0A0F',
      color: '#F0EDE8',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Georgia, serif',
      fontSize: 24,
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, fontWeight: 700, color: '#B89B5E', marginBottom: 16 }}>Neural News</div>
        <div style={{ color: '#5B616E' }}>Loading Smart TV app…</div>
      </div>
    </div>
  );
}
